import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import {
  RiMenu4Line,
  RiDashboardLine,
  RiBloggerLine,
  RiBloggerFill,
} from "react-icons/ri";
import { IoClose } from "react-icons/io5";
import { MdSell } from "react-icons/md";
import { FaFileVideo, FaTools } from "react-icons/fa";

const Sidebar = ({ isSidebarOpen, setIsSidebarOpen }) => {
  const navigate = useNavigate();
  const path = useLocation();

  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

  const menuItems = [
    {
      label: "Dashboard",
      icon: <RiDashboardLine size={22} />,
      path: "/dashboard",
    },
    { label: "Products", icon: <MdSell size={22} />, path: "/products" },
    { label: "Services", icon: <FaTools size={22} />, path: "/services" },
    { label: "Blogs", icon: <RiBloggerFill size={22} />, path: "/all-blogs" },
    {
      label: "Add Videoes",
      icon: <FaFileVideo size={22} />,
      path: "/add-videoes",
    },
  ];

  const renderMenuItems = () => (
    <ul className="space-y-2">
      {menuItems.map((item) => (
        <li key={item.path}>
          <div
            onClick={() => {
              navigate(item.path);
              setIsSidebarOpen(false); // close sidebar on mobile
            }}
            className={`flex items-center p-2 rounded-lg cursor-pointer text-base ${
              path.pathname === item.path
                ? "bg-primaryColor text-white font-medium"
                : "text-primaryTextColor font-normal hover:bg-gray-100"
            }`}
          >
            {item.icon}
            <span className="ml-3">{item.label}</span>
          </div>
        </li>
      ))}
    </ul>
  );

  return (
    <>
      {/* Sidebar button for mobile */}
      <div className="lg:hidden fixed top-4 left-4 z-50">
        <button
          onClick={toggleSidebar}
          className="text-primaryColor bg-white p-2 rounded-full shadow-md"
        >
          {isSidebarOpen ? <IoClose size={24} /> : <RiMenu4Line size={24} />}
        </button>
      </div>

      {/* Desktop Sidebar */}
      <div className="hidden lg:flex lg:flex-shrink-0">
        <div className="w-64 h-screen bg-white shadow-2xl overflow-y-auto p-4">
          {renderMenuItems()}
        </div>
      </div>

      {/* Mobile Sidebar */}
      <AnimatePresence>
        {isSidebarOpen && (
          <motion.div
            className="fixed inset-0 z-40 flex pt-[3.9rem] lg:pt-0"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.2 }}
          >
            {/* Overlay */}
            <div
              className="fixed inset-0 bg-black bg-opacity-50"
              onClick={toggleSidebar}
            />

            {/* Sidebar Panel */}
            <motion.div
              className="relative w-3/4 max-w-xs bg-white shadow-2xl h-full p-4"
              initial={{ x: "-100%" }}
              animate={{ x: 0 }}
              exit={{ x: "-100%" }}
              transition={{ duration: 0.3 }}
            >
              {renderMenuItems()}
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default Sidebar;
